import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'defaultInlineListTransform' })
export class DefaultInlineListPipe implements PipeTransform {

    transform(value: any[]) {
        return value && value.length > 0 ? value.map(item => item.nom).join(", ") : 'Voir';
    }

}